"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // 8px

var unit1 = exports.unit1 = "8px"; // 2px

var unitQuarter = exports.unitQuarter = "$unit-1 / 4"; // 4px

var unitHalf = exports.unitHalf = "$unit-1 / 2"; // 16px

var unit2 = exports.unit2 = "2 * $unit-1"; // 24px

var unit3 = exports.unit3 = "3 * $unit-1"; // 32px

var unit4 = exports.unit4 = "4 * $unit-1"; // 40px

var unit5 = exports.unit5 = "5 * $unit-1"; // 48px

var unit6 = exports.unit6 = "6 * $unit-1"; // 56px

var unit7 = exports.unit7 = "7 * $unit-1"; // 64px

var unit8 = exports.unit8 = "8 * $unit-1"; // 72px

var unit9 = exports.unit9 = "9 * $unit-1"; // 80px

var unit10 = exports.unit10 = "10 * $unit-1"; // 120px

var unit15 = exports.unit15 = "15 * $unit-1"; // 160px

var unit20 = exports.unit20 = "20 * $unit-1"; // 200px

var unit25 = exports.unit25 = "25 * $unit-1"; // 240px

var unit30 = exports.unit30 = "30 * $unit-1"; // 280px

var unit35 = exports.unit35 = "35 * $unit-1"; // 320px

var unit40 = exports.unit40 = "40 * $unit-1"; // 360px

var unit45 = exports.unit45 = "45 * $unit-1"; // 400px

var unit50 = exports.unit50 = "50 * $unit-1"; // 440px

var unit55 = exports.unit55 = "55 * $unit-1"; // 500px

var unit60 = exports.unit60 = "60 * $unit-1"; // 540px

var unit65 = exports.unit65 = "65 * $unit-1"; // 580px

var unit70 = exports.unit70 = "70 * $unit-1"; // 620px

var unit75 = exports.unit75 = "75 * $unit-1"; // 660px

var unit80 = exports.unit80 = "80 * $unit-1"; // 700px

var unit90 = exports.unit90 = "90 * $unit-1"; // 740px

var unit100 = exports.unit100 = "100 * $unit-1"; // 780px

var unit110 = exports.unit110 = "110 * $unit-1"; // 820px

var unit120 = exports.unit120 = "120 * $unit-1";
var zIndexOverlay = exports.zIndexOverlay = "1000";
var zIndexDialog = exports.zIndexDialog = "900";
var zIndexAlert = exports.zIndexAlert = "800";
var zIndexFlash = exports.zIndexFlash = "700";
var zIndexMainNav = exports.zIndexMainNav = "600";
var zIndexForm = exports.zIndexForm = "500";
var zIndexPanel = exports.zIndexPanel = "400";
var zIndexMainPanel = exports.zIndexMainPanel = "400";
var zIndexSubPanel = exports.zIndexSubPanel = "400";
var zIndexHeader = exports.zIndexHeader = "300";
var zIndexEditable = exports.zIndexEditable = "200";
var zIndexContent = exports.zIndexContent = "100";
var zIndexGround = exports.zIndexGround = "1";
var mqXsmall = exports.mqXsmall = "screen and (max-width: 464px)";
var mqSmall = exports.mqSmall = "screen and (min-width: 465px) and (max-width: 728px)";
var mqSmallUp = exports.mqSmallUp = "screen and (min-width: 465px)";
var mqMedium = exports.mqMedium = "screen and (min-width: 729px) and (max-width: 1076px)";
var mqMediumUp = exports.mqMediumUp = "screen and (min-width: 729px)";
var mqLarge = exports.mqLarge = "screen and (min-width: 1077px) and (max-width: 1436px)";
var mqLargeUp = exports.mqLargeUp = "screen and (min-width: 1077px)";
var mqXlarge = exports.mqXlarge = "screen and (min-width: 1436px)";
var mqXlargeUp = exports.mqXlargeUp = "screen and (min-width: 1436px)";